import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "../../components/Layout";
import { PageHero, ProseSection, EndCTA, BulletList } from "../../components/PageParts";

export default function EnLigne() {
  const BC = [{ to: "/", label: "Accueil" }, { to: "/votre-seance", label: "Votre séance" }, { label: "Séance en ligne" }];
  return (
    <>
      <Seo
        title="Séance d'hypnose en ligne"
        description="Séance d'hypnose en visioconférence avec Valentine DL : la même qualité qu'en présentiel, dans le confort de chez vous. Modalités et conseils pour bien se préparer."
        canonical="https://www.parfaitsimparfaits.fr/votre-seance/en-ligne"
      />
      <PageHero breadcrumb={BC} eyebrow="À distance" title="La séance d'hypnose" italic="en ligne, en visio." />
      <ProseSection>
        <p>
          La grande majorité de mes séances se déroulent aujourd'hui <strong className="text-sand-900 font-medium">en
          visioconférence</strong>. L'expérience est aussi qualitative qu'{" "}
          <Link to="/votre-seance/cabinet-pantin" className="text-[#B07A45] underline hover:text-sand-900">
            en présentiel au cabinet à Pantin
          </Link>{" "}
          — et le confort de votre propre espace facilite souvent le lâcher-prise.
        </p>
        <h2 className="font-serif text-3xl text-sand-900">Ce dont vous avez besoin</h2>
        <BulletList
          items={[
            "Un ordinateur, une tablette ou un téléphone avec caméra",
            "Une connexion internet stable",
            "Des écouteurs ou un casque (recommandé, pour un son enveloppant)",
            "Un endroit calme où vous ne serez pas dérangé·e pendant environ 1h30 (ericksonienne) ou 2h30 (spirituelle)",
            "Un fauteuil ou un lit confortable, une couverture légère si vous êtes sensible au froid",
          ]}
        />
        <h2 className="font-serif text-3xl text-sand-900">Comment ça se passe</h2>
        <p>
          Je vous envoie un lien de visioconférence sécurisé (Zoom ou Google Meet) quelques minutes avant l'heure du
          rendez-vous. La{" "}
          <Link to="/votre-seance/deroulement" className="text-[#B07A45] underline hover:text-sand-900">
            structure de la séance
          </Link>{" "}
          est exactement la même qu'en présentiel&nbsp;: échange préalable, hypnose guidée par la voix, intégration.
        </p>
        <p>
          <strong className="text-sand-900 font-medium">Règlement</strong>&nbsp;: à la réservation, par virement bancaire
          ou PayPal. Un e-mail de confirmation vous est envoyé après validation. Les{" "}
          <Link to="/votre-seance/tarifs" className="text-[#B07A45] underline hover:text-sand-900">
            tarifs
          </Link>{" "}
          restent identiques quel que soit le mode de séance.
        </p>
      </ProseSection>
      <EndCTA testid="en-ligne-end" />
    </>
  );
}
